<div class="edit_info_main_header">Crafting Your Business Story</div>
<div style="background-color:white;color: black;width: auto;height: 100%;">
    <div class="edit_info_main_container">
        <div>
            <div class="row col-md-12">
                <div class="edit_info_header">Business Information</div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">Business Name&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput placeholder="Business Name" [formControl]="BusinessInfo_BusinessName"
                            type="text">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">work</mat-icon>
                        <mat-error *ngIf="BusinessInfo_BusinessName.invalid && BusinessInfo_BusinessName.touched">
                            Business Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <div class="edit_info_side_headers">Business Category&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select placeholder="Select Category" [formControl]="BusinessInfo_BusinessCategory"
                            (selectionChange)="onCategoryChange($event.value)">
                            <mat-option *ngFor="let category of categories" [value]="category.name">
                                {{ category.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="BusinessInfo_BusinessCategory.invalid && BusinessInfo_BusinessCategory.touched">
                            Business Category is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4" *ngIf="subCategories.length > 0">
                    <div class="edit_info_side_headers">Business Codes&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <!-- Removed duplicated mat-select tag -->
                        <mat-select placeholder="Select Code" [formControl]="BusinessInfo_BusinessCode">
                            <mat-option *ngFor="let subCategory of subCategories" [value]="subCategory">
                                {{ subCategory }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="BusinessInfo_BusinessCode.invalid && BusinessInfo_BusinessCode.touched">
                            Business Code is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <div class="edit_info_side_headers">Business Type&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select placeholder="Business Type" [formControl]="BusinessInfo_BusinessType">
                            <mat-option *ngFor="let option of type" [value]="option.value">
                                {{ option.viewValue }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="BusinessInfo_BusinessType.invalid && BusinessInfo_BusinessType.touched">
                            Business Type is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <div class="edit_info_side_headers">Website URL</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput placeholder="URL" type="text" [formControl]="BusinessInfo_WebsiteURL">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">link</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <div class="row col-md-12">
                <div class="edit_info_header">Current Online Presence</div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">Do you currently sell online ?&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select [formControl]="CurrentOnlinePresence_DoYouCurrentlySellOnline"
                            placeholder="Select Value">
                            <mat-option value="yes">Yes</mat-option>
                            <mat-option value="no">No</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="CurrentOnlinePresence_DoYouCurrentlySellOnline.invalid && CurrentOnlinePresence_DoYouCurrentlySellOnline.touched">
                            Option Required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4" *ngIf="CurrentOnlinePresence_DoYouCurrentlySellOnline.value === 'yes'">
                    <div class="edit_info_side_headers">Monthly online sales figures :</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput [formControl]="onlineSales" placeholder="Enter your answer">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">123</mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-md-4" *ngIf="CurrentOnlinePresence_DoYouCurrentlySellOnline.value === 'no'">
                    <div class="edit_info_side_headers">Monthly offline footfall :</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput [formControl]="offlineFootfall" placeholder="Enter your answer">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">123</mat-icon>
                    </mat-form-field>

                </div>

                <div class="col-md-4">
                    <div class="edit_info_side_headers">Current number of Instagram followers :</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput type="number" placeholder="Enter the number" min="0"
                            [formControl]="CurrentOnlinePresence_InstagramFollowers">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">person_add</mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <div class="edit_info_side_headers">Instagram Username :</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput placeholder="Enter your Instagram Username"
                            [formControl]="CurrentOnlinePresence_InstagramUsername">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">person</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">LinkedIn Username :</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <input matInput placeholder="Enter your LinkedIn Username"
                            [formControl]="CurrentOnlinePresence_LinkedInUsername">
                        <mat-icon matSuffix class="material-symbols-outlined"
                            style="display: inline-block;">person</mat-icon>
                    </mat-form-field>
                </div>

            </div>

            <div class="row col-md-12">
                <div class="edit_info_header">Content Requirements</div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">What type of content are you interested in ?&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select placeholder="Select Value" [formControl]="ContentRequirements_IntrestedContent"
                            multiple>
                            <mat-option value="Reels">Reels</mat-option>
                            <mat-option value="Photos">Photos</mat-option>
                            <mat-option value="Carousels">Carousels</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="ContentRequirements_IntrestedContent.invalid && ContentRequirements_IntrestedContent.touched">
                            Interested Content is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">Do you have specific themes or styles in mind ?&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select [formControl]="ContentRequirements_SpecificThemes" placeholder="Select Value">
                            <mat-option value="yes">Yes</mat-option>
                            <mat-option value="no">No</mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="ContentRequirements_SpecificThemes.invalid && ContentRequirements_SpecificThemes.touched">
                            Specific Themes is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4"></div>
                <div class="col-md-8" *ngIf="ContentRequirements_SpecificThemes.value === 'yes'">
                    <div class="edit_info_side_headers">If yes, please describe or upload examples</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">

                        <textarea rows="7" matInput [formControl]="ContentRequirements_Description"></textarea>
                    </mat-form-field>
                    <div class="photo_upload">



                        <button class="photo_button" (click)="fileInput1.click()">Upload Photos</button>

                        <input type="file" #fileInput1 accept="image/*" (change)="onFileSelected($event, 'ContentRequirements')" multiple
                            style="display: none;" />

                        <div *ngIf="Content_Requirements_Sample_Images.length > 0" style="height: 200px; overflow-x: hidden;">
                            <div *ngFor="let image of Content_Requirements_Sample_Images;let i = index"
                                style="display: inline-block; margin: 10px; position: relative">
                                <img [src]="image" alt="Selected Photo"
                                    style="max-width: auto; height: 172px;border: 2px solid #ddd;">
                                <button (click)="deleteImage(i,Content_Requirements_Sample_Images)" class="delete_image">X</button>
                            </div>

                        </div>
                    </div>


                </div>
            </div>


            <div class="row col-md-12">
                <div class="edit_info_header">Target Audience</div>

                <div class="edit_info_side_headers">Who is your target audience ?&nbsp;*</div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">AGE :&nbsp;*</div>
                    <div class="row">
                        <mat-form-field appearance="outline" class="age col-md-6" required>
                            <input matInput type="number" placeholder="From" min="0"
                                [formControl]="TargetAudience_FromAge">
                            <mat-error *ngIf="TargetAudience_FromAge.invalid && TargetAudience_FromAge.touched">
                                From Age is required
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="age col-md-6" required>
                            <input matInput type="number" placeholder="To" min="0" [formControl]="TargetAudience_ToAge">
                            <mat-error *ngIf="TargetAudience_ToAge.invalid && TargetAudience_ToAge.touched">
                                To Age is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="edit_info_side_headers">GENDER :&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select placeholder="Select your gender" [formControl]="TargetAudience_Gender">
                            <mat-option value="MALE">MALE</mat-option>
                            <mat-option value="FEMALE">FEMALE</mat-option>
                            <mat-option value="BOTH">BOTH</mat-option>
                        </mat-select>
                        <mat-error *ngIf="TargetAudience_Gender.invalid && TargetAudience_Gender.touched">
                            Gender is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-8">
                    <div class="edit_info_side_headers">INTERESTS :&nbsp;*</div>
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <textarea rows="7" matInput [formControl]="TargetAudience_Interests" placeholder=""></textarea>
                        <mat-error *ngIf="TargetAudience_Interests.invalid && TargetAudience_Interests.touched">
                            Interests are required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="edit_info_side_headers">Any specific geographic location you are targeting?</div>
                <div class="col-md-4">
                    <ul id="tags">
                        <mat-form-field appearance="outline" class="edit_info_form_fields">
                            <li *ngFor="let tag of tags" class="tag">
                                {{ tag }}
                                <span class="close-btn" (click)="removeTag(tag)">&times;</span>
                            </li>
                            <input matInput placeholder="Enter your answer" [(ngModel)]="inputValue"
                                (keydown)="handleKeyDown($event)" />
                            <mat-icon matSuffix class="material-symbols-outlined"
                                style="display: inline-block;">location_on</mat-icon>
                        </mat-form-field>

                    </ul>
                </div>
            </div>

            <div class="row col-md-12">
                <div class="edit_info_header">Content Goals</div>
                <div class="edit_info_side_headers">What are your primary goals for this content ?&nbsp;*</div>
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <mat-select placeholder="Select Value" [formControl]="ContentGoals_PrimaryGoals" multiple>
                            <!-- <mat-select placeholder="Select Value" [formControl]="ContentGoals_PrimaryGoals" multiple> -->
                            <mat-option value="Brand Awareness">Brand Awareness</mat-option>
                            <mat-option value="Engagement">Engagement</mat-option>
                            <mat-option value="Sales">Sales</mat-option>
                        </mat-select>
                        <mat-error *ngIf="ContentGoals_PrimaryGoals.invalid && ContentGoals_PrimaryGoals.touched">
                            Content Goals are required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-9"></div>
                <div class="edit_info_side_headers">Are there any key messages or brand values you want to
                    communicate?
                </div>
                <div class="col-md-8">
                    <mat-form-field appearance="outline" class="edit_info_form_fields">
                        <textarea rows="7" matInput placeholder="" [formControl]="ContentGoals_KeyMessages"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="edit_info_header">Regular Posting Schedule</div>
            <div class="edit_info_side_headers">Monday to Friday: Posts</div>
            <div class="edit_info_side_headers">Saturday: Reels</div>
            <div class="edit_info_side_headers">Sunday: Carousel</div>
            <div class="edit_info_side_headers">Do you want to customize this schedule?&nbsp;*</div>
            <div class="col-md-4">
                <mat-form-field appearance="outline" class="edit_info_form_fields">
                    <mat-select [formControl]="RegularPostingSchedule_Customize" placeholder="Select Value"
                        (selectionChange)="onScheduleChange()">
                        <mat-option value="yes">Yes</mat-option>
                        <mat-option value="no">No</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="RegularPostingSchedule_Customize.invalid && RegularPostingSchedule_Customize.touched">
                        Regular Posting Schedule is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div *ngIf="RegularPostingSchedule_Customize.value === 'yes'">
                <div class="edit_info_side_headers">If yes, please provide your preferred posting schedule:</div>
                <div class="week_schedule">
                    <div class="row day_dropdown">
                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Monday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Mon"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Tuesday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Tue"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Wednesday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Wed"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Thursday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Thu"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Friday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Fri"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Saturday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Sat"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-4">
                            <mat-form-field appearance="outline" class="edit_info_form_fields">
                                <mat-label style="color: white;">Sunday</mat-label>
                                <mat-select [formControl]="RegularPostingSchedule_Sun"
                                    (selectionChange)="onScheduleChange()">
                                    <mat-option value="Post">Post</mat-option>
                                    <mat-option value="Reel">Reel</mat-option>
                                    <mat-option value="Carousel">Carousel</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="error_message" *ngIf="errorMessage">
                        {{ errorMessage }}
                    </div>
                </div>
            </div>
            <div class="edit_info_header">Business Specific Uploads</div>
            <div class="edit_info_side_headers">If Cafe: Please upload your menu.</div>
            <div class="photo_upload">
                <button class="photo_button" (click)="fileInput2.click()">Upload Photos</button>

                <input type="file" #fileInput2 accept="image/*" (change)="onFileSelected($event, 'BusinessSpecificUploads')" multiple 
                    style="display: none;" />
                <div *ngIf="Business_Specific_Uploads_Images.length > 0" style="height: 200px; overflow-x: hidden;">
                    <div *ngFor="let image of Business_Specific_Uploads_Images; let i = index"
                        style="display: inline-block; position: relative; margin: 10px;">
                        <img [src]="image" alt="Selected Photo"
                            style="width: auto; height: 172px;border: 2px solid #ddd;">
                        <button (click)="deleteImage(i,Business_Specific_Uploads_Images)" class="delete_image">X</button>
                    </div>
                </div>

            </div>

            <div class="edit_info_side_headers">For Other Businesses: Please upload a list of your services.&nbsp;*
            </div>
            <div class="col-md-8">
                <mat-form-field appearance="outline" class="edit_info_form_fields">
                    <textarea rows="7" [formControl]="BusinessSpecificUploads_Services" matInput
                        placeholder=""></textarea>
                    <mat-error
                        *ngIf="BusinessSpecificUploads_Services.invalid && BusinessSpecificUploads_Services.touched">
                        Please upload a list of your services is required
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="edit_info_header">Competitor Information</div>
            <div class="col-md-8">
                <div class="edit_info_side_headers">List any competitors you want to differentiate from or benchmark
                    against.</div>
                <mat-form-field appearance="outline" class="page_form_fields" style="width: 100%;">
                    <textarea rows="7" [formControl]="CompetitorInformation_Details" matInput placeholder=""></textarea>
                </mat-form-field>
            </div>

            <div class="edit_info_header">Additional Details</div>
            <div class="edit_info_side_headers">Any additional information you think we should know?</div>
            <div class="col-md-8">
                <mat-form-field appearance="outline" class="edit_info_form_fields">
                    <textarea rows="7" [formControl]="AdditionalDetails_Details" matInput placeholder=""></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="" style="text-align: center;padding: 20px 0px 30px 0px;">
            <button (click)="onUpdate()" class="update_button" style="margin: 0%;">Update</button>
        </div>
    </div>

</div>